import React, { useEffect } from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
import { useSEO } from '../utils/seo';
export const PolitiqueConfidentialite = () => {
  useSEO({
    title: 'Politique de Confidentialité | Dispel Your Tattoo',
    description: 'Politique de confidentialité et gestion des données personnelles de Dispel Your Tattoo, studio de détatouage laser à Martigny.',
    canonical: 'https://www.dispelyourtattoo.ch/politique-de-confidentialite'
  });
  return <main className="pt-32 pb-24" data-id="element-969">
      <div className="max-w-[800px] mx-auto px-6 md:px-12" data-id="element-970">
        <ScrollReveal data-id="element-971">
          <h1 className="text-4xl md:text-5xl font-medium text-brand-light mb-12 tracking-tight" data-id="element-972">
            Politique de confidentialité
          </h1>
        </ScrollReveal>

        <div className="space-y-10 text-brand-gray font-light leading-[1.85] text-base md:text-lg" data-id="element-973">
          <ScrollReveal delay={0.1} data-id="element-974">
            <section data-id="element-975">
              <h2 className="text-xl font-medium text-brand-light mb-4" data-id="element-976">
                1. Introduction
              </h2>
              <p data-id="element-977">
                Dispel Your Tattoo, dont le siège est situé Rue de la Délèze 2,
                1920 Martigny, Suisse, s'engage à protéger la vie privée des
                utilisateurs de son site internet{' '}
                <strong className="text-brand-light" data-id="element-978">
                  www.dispelyourtattoo.ch
                </strong>
                .
              </p>
              <p className="mt-4" data-id="element-979">
                La présente politique de confidentialité décrit les types de
                données personnelles collectées, les finalités de leur
                traitement, ainsi que les droits dont vous disposez conformément
                à la Loi fédérale suisse sur la protection des données (LPD) et,
                le cas échéant, au Règlement général sur la protection des
                données (RGPD) de l'Union européenne.
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.15} data-id="element-980">
            <section data-id="element-981">
              <h2 className="text-xl font-medium text-brand-light mb-4" data-id="element-982">
                2. Données collectées
              </h2>
              <p data-id="element-983">
                Nous collectons les données personnelles suivantes lorsque vous
                utilisez nos formulaires de contact ou de consultation :
              </p>
              <ul className="mt-4 list-disc pl-5 space-y-2" data-id="element-984">
                <li data-id="element-985">Nom et prénom</li>
                <li data-id="element-986">Adresse email</li>
                <li data-id="element-987">Numéro de téléphone</li>
                <li data-id="element-988">
                  Informations relatives au tatouage (zone, taille, couleurs,
                  ancienneté)
                </li>
                <li data-id="element-989">Photographies du tatouage (si fournies volontairement)</li>
                <li data-id="element-990">Contenu des messages envoyés via les formulaires</li>
              </ul>
              <p className="mt-4" data-id="element-991">
                Ces données sont collectées uniquement lorsque vous les
                fournissez volontairement via nos formulaires en ligne.
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.2} data-id="element-992">
            <section data-id="element-993">
              <h2 className="text-xl font-medium text-brand-light mb-4" data-id="element-994">
                3. Finalités du traitement
              </h2>
              <p data-id="element-995">
                Vos données personnelles sont utilisées exclusivement pour :
              </p>
              <ul className="mt-4 list-disc pl-5 space-y-2" data-id="element-996">
                <li data-id="element-997">
                  Répondre à vos demandes de consultation ou de renseignement
                </li>
                <li data-id="element-998">Préparer et personnaliser votre prise en charge</li>
                <li data-id="element-999">
                  Vous recontacter dans le cadre de votre projet de détatouage
                </li>
                <li data-id="element-1000">Améliorer la qualité de nos services</li>
              </ul>
              <p className="mt-4" data-id="element-1001">
                Vos données ne sont jamais vendues, louées ou transmises à des
                tiers à des fins commerciales.
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.25} data-id="element-1002">
            <section data-id="element-1003">
              <h2 className="text-xl font-medium text-brand-light mb-4" data-id="element-1004">
                4. Durée de conservation
              </h2>
              <p data-id="element-1005">
                Vos données personnelles sont conservées pendant la durée
                nécessaire à la finalité pour laquelle elles ont été collectées,
                et au maximum pendant une durée de 3 ans à compter de votre
                dernier contact avec Dispel Your Tattoo, sauf obligation légale
                contraire.
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.3} data-id="element-1006">
            <section data-id="element-1007">
              <h2 className="text-xl font-medium text-brand-light mb-4" data-id="element-1008">
                5. Cookies
              </h2>
              <p data-id="element-1009">
                Le site www.dispelyourtattoo.ch utilise des cookies pour
                améliorer l'expérience utilisateur et analyser le trafic du
                site.
              </p>
              <p className="mt-4" data-id="element-1010">
                La gestion des cookies est assurée par{' '}
                <strong className="text-brand-light" data-id="element-1011">CookieYes</strong>, une
                plateforme de gestion du consentement. Lors de votre première
                visite, un bandeau de consentement vous permet de choisir les
                catégories de cookies que vous acceptez.
              </p>
              <p className="mt-4" data-id="element-1012">Les catégories de cookies utilisées sont :</p>
              <ul className="mt-4 list-disc pl-5 space-y-2" data-id="element-1013">
                <li data-id="element-1014">
                  <strong className="text-brand-light" data-id="element-1015">
                    Cookies nécessaires :
                  </strong>{' '}
                  indispensables au fonctionnement du site. Ils ne peuvent pas
                  être désactivés.
                </li>
                <li data-id="element-1016">
                  <strong className="text-brand-light" data-id="element-1017">
                    Cookies analytiques :
                  </strong>{' '}
                  permettent de mesurer l'audience et d'analyser le comportement
                  des visiteurs (ex. Google Analytics).
                </li>
                <li data-id="element-1018">
                  <strong className="text-brand-light" data-id="element-1019">
                    Cookies fonctionnels :
                  </strong>{' '}
                  améliorent l'expérience utilisateur en mémorisant vos
                  préférences.
                </li>
              </ul>
              <p className="mt-4" data-id="element-1020">
                Vous pouvez modifier vos préférences de cookies à tout moment en
                cliquant sur le lien « Gérer les cookies » disponible en bas de
                page, ou directement via le bandeau CookieYes.
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.35} data-id="element-1021">
            <section data-id="element-1022">
              <h2 className="text-xl font-medium text-brand-light mb-4" data-id="element-1023">
                6. Sécurité des données
              </h2>
              <p data-id="element-1024">
                Dispel Your Tattoo met en œuvre des mesures techniques et
                organisationnelles appropriées pour protéger vos données
                personnelles contre tout accès non autorisé, toute modification,
                divulgation ou destruction.
              </p>
              <p className="mt-4" data-id="element-1025">
                Le site utilise le protocole HTTPS pour sécuriser les échanges
                de données entre votre navigateur et notre serveur.
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.4} data-id="element-1026">
            <section data-id="element-1027">
              <h2 className="text-xl font-medium text-brand-light mb-4" data-id="element-1028">
                7. Vos droits
              </h2>
              <p data-id="element-1029">
                Conformément à la législation applicable, vous disposez des
                droits suivants :
              </p>
              <ul className="mt-4 list-disc pl-5 space-y-2" data-id="element-1030">
                <li data-id="element-1031">
                  <strong className="text-brand-light" data-id="element-1032">Droit d'accès :</strong>{' '}
                  obtenir la confirmation que vos données sont traitées et en
                  recevoir une copie.
                </li>
                <li data-id="element-1033">
                  <strong className="text-brand-light" data-id="element-1034">
                    Droit de rectification :
                  </strong>{' '}
                  demander la correction de données inexactes ou incomplètes.
                </li>
                <li data-id="element-1035">
                  <strong className="text-brand-light" data-id="element-1036">
                    Droit à l'effacement :
                  </strong>{' '}
                  demander la suppression de vos données personnelles.
                </li>
                <li data-id="element-1037">
                  <strong className="text-brand-light" data-id="element-1038">
                    Droit à la limitation :
                  </strong>{' '}
                  demander la restriction du traitement de vos données.
                </li>
                <li data-id="element-1039">
                  <strong className="text-brand-light" data-id="element-1040">
                    Droit d'opposition :
                  </strong>{' '}
                  vous opposer au traitement de vos données pour des motifs
                  légitimes.
                </li>
                <li data-id="element-1041">
                  <strong className="text-brand-light" data-id="element-1042">
                    Droit à la portabilité :
                  </strong>{' '}
                  recevoir vos données dans un format structuré et couramment
                  utilisé.
                </li>
              </ul>
              <p className="mt-4" data-id="element-1043">
                Pour exercer ces droits, veuillez nous contacter à l'adresse :{' '}
                <a href="mailto:dispeltattoo@gmail.com" className="text-brand-light underline hover:text-white transition-colors" data-id="element-1044">
                  dispeltattoo@gmail.com
                </a>
                .
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.45} data-id="element-1045">
            <section data-id="element-1046">
              <h2 className="text-xl font-medium text-brand-light mb-4" data-id="element-1047">
                8. Modifications
              </h2>
              <p data-id="element-1048">
                Dispel Your Tattoo se réserve le droit de modifier la présente
                politique de confidentialité à tout moment. Les modifications
                prennent effet dès leur publication sur le site. Nous vous
                encourageons à consulter régulièrement cette page.
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.5} data-id="element-1049">
            <section data-id="element-1050">
              <h2 className="text-xl font-medium text-brand-light mb-4" data-id="element-1051">
                9. Contact
              </h2>
              <p data-id="element-1052">
                Pour toute question relative à la protection de vos données
                personnelles, vous pouvez nous contacter :
              </p>
              <ul className="mt-4 space-y-1" data-id="element-1053">
                <li data-id="element-1054">
                  <strong className="text-brand-light" data-id="element-1055">Email :</strong>{' '}
                  <a href="mailto:dispeltattoo@gmail.com" className="text-brand-light underline hover:text-white transition-colors" data-id="element-1056">
                    dispeltattoo@gmail.com
                  </a>
                </li>
                <li data-id="element-1057">
                  <strong className="text-brand-light" data-id="element-1058">Téléphone :</strong> 079
                  102 69 45
                </li>
                <li data-id="element-1059">
                  <strong className="text-brand-light" data-id="element-1060">Adresse :</strong> Rue de
                  la Délèze 2, 1920 Martigny, Suisse
                </li>
              </ul>
            </section>
          </ScrollReveal>
        </div>
      </div>
    </main>;
};